module.exports = __webpack_public_path__ + "img/alliance-retail-group_logo.5784aca8.png";